<template>
  <AgentPermissions
    :permissions="transformedPermissions"
    :title="title"
    @change="changePermission"
    @selectAll="changeAll(true)"
    @deselectAll="changeAll(false)"
  />
</template>

<script>
import cloneDeep from 'lodash.clonedeep';
import deepSetObjectProperty from '@/utils/deepSetObjectProperty';

import AgentPermissions from './AgentPermissions';
import {
  translateGeneralPermission,
  translatePermissionCategory,
} from './utils/permissionsTranslators';

import permissionRelations from './utils/permissionRelations';

export default {
  name: 'AgentGeneralPermissions',
  components: {
    AgentPermissions,
  },
  model: {
    prop: 'permissions',
    event: 'input',
  },
  props: {
    permissions: {
      required: true,
      type: Object,
    },
    selectedGeneralPermissionGroup: {
      required: true,
      type: String,
    },
  },
  computed: {
    title() {
      return translatePermissionCategory(this.selectedGeneralPermissionGroup);
    },
    transformedPermissions() {
      return Object.keys(this.currentPermission).map(perm => {
        const { title, description } = translateGeneralPermission(perm);
        return {
          title,
          description,
          property: perm,
          value: this.currentPermission[perm],
        };
      });
    },
    currentPermission() {
      return this.permissions.general_permissions[
        this.selectedGeneralPermissionGroup
      ];
    },
  },
  methods: {
    changeAll(val) {
      const clonedGeneralPermissions = cloneDeep(this.permissions);
      Object.keys(this.currentPermission).forEach(perm => {
        this.setValueAndRelations({
          permissions: clonedGeneralPermissions,
          value: val,
          property: perm,
        });
      });
      this.submitChange(clonedGeneralPermissions);
    },
    changePermission({ property, value }) {
      const clonedGeneralPermissions = cloneDeep(this.permissions);
      this.setValueAndRelations({
        permissions: clonedGeneralPermissions,
        value,
        property,
      });
      this.submitChange(clonedGeneralPermissions);
    },
    setValueAndRelations({ property, value, permissions }) {
      permissions.general_permissions[this.selectedGeneralPermissionGroup][
        property
      ] = value;
      const permissionKey = `general_permissions.${this.selectedGeneralPermissionGroup}.${property}`;
      if (permissionKey in permissionRelations) {
        const { relatedTo, action, on } = permissionRelations[permissionKey];
        if (on === value)
          deepSetObjectProperty({
            obj: permissions,
            property: relatedTo,
            value: action,
          });
      }
    },
    submitChange(permissions) {
      this.$emit('input', permissions);
    },
  },
};
</script>
